"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanningApplicationsWrapper$ = exports.PlanningApplicationsWrapper$outboundSchema = exports.PlanningApplicationsWrapper$inboundSchema = void 0;
exports.planningApplicationsWrapperToJSON = planningApplicationsWrapperToJSON;
exports.planningApplicationsWrapperFromJSON = planningApplicationsWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const planningapplication_js_1 = require("./planningapplication.js");
/** @internal */
exports.PlanningApplicationsWrapper$inboundSchema = z.object({
    planning_application_objects: z.nullable(z.array(planningapplication_js_1.PlanningApplication$inboundSchema)),
    planning_applications_available: z.boolean(),
    planning_applications_available_text: z.string(),
    planning_portal_url: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "planning_application_objects": "planningApplicationObjects",
        "planning_applications_available": "planningApplicationsAvailable",
        "planning_applications_available_text": "planningApplicationsAvailableText",
        "planning_portal_url": "planningPortalUrl",
    });
});
/** @internal */
exports.PlanningApplicationsWrapper$outboundSchema = z.object({
    planningApplicationObjects: z.nullable(z.array(planningapplication_js_1.PlanningApplication$outboundSchema)),
    planningApplicationsAvailable: z.boolean(),
    planningApplicationsAvailableText: z.string(),
    planningPortalUrl: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        planningApplicationObjects: "planning_application_objects",
        planningApplicationsAvailable: "planning_applications_available",
        planningApplicationsAvailableText: "planning_applications_available_text",
        planningPortalUrl: "planning_portal_url",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PlanningApplicationsWrapper$;
(function (PlanningApplicationsWrapper$) {
    /** @deprecated use `PlanningApplicationsWrapper$inboundSchema` instead. */
    PlanningApplicationsWrapper$.inboundSchema = exports.PlanningApplicationsWrapper$inboundSchema;
    /** @deprecated use `PlanningApplicationsWrapper$outboundSchema` instead. */
    PlanningApplicationsWrapper$.outboundSchema = exports.PlanningApplicationsWrapper$outboundSchema;
})(PlanningApplicationsWrapper$ || (exports.PlanningApplicationsWrapper$ = PlanningApplicationsWrapper$ = {}));
function planningApplicationsWrapperToJSON(planningApplicationsWrapper) {
    return JSON.stringify(exports.PlanningApplicationsWrapper$outboundSchema.parse(planningApplicationsWrapper));
}
function planningApplicationsWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PlanningApplicationsWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PlanningApplicationsWrapper' from JSON`);
}
//# sourceMappingURL=planningapplicationswrapper.js.map